var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8749 11.4375C14.6666 11.3333 14.5624 11.2292 14.3541 11.2292C17.0624 9.14583 17.5833 5.1875 15.3958 2.47917C13.2083 -0.229166 9.35408 -0.75 6.64575 1.4375C3.93742 3.625 3.41659 7.47917 5.60409 10.1875C5.91659 10.6042 6.22909 10.9167 6.64575 11.2292C6.54159 11.3333 6.33325 11.3333 6.22908 11.4375C6.22908 11.4375 6.22909 11.4375 6.12492 11.4375C2.79159 13 0.499919 16.125 0.083252 19.7708C0.083252 20.2917 0.499919 20.8125 1.12492 20.9167H19.8749C20.3958 20.8125 20.8124 20.2917 20.8124 19.7708C20.4999 16.125 18.2083 13 14.8749 11.4375ZM6.33325 5.91667C6.54158 3.625 8.62492 1.95833 10.8124 2.16667C12.7916 2.375 14.3541 3.9375 14.5624 5.91667H6.33325ZM10.4999 14.875L8.52075 12.8958C9.87492 12.5833 11.2291 12.5833 12.5833 12.8958L10.4999 14.875Z",
    fill: "#52447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.38bcb6de034000fed7bbe9f5c3b7a309.svg";
export { ForwardRef as ReactComponent };